// extracted by mini-css-extract-plugin
export default {"wrapper":"AncetTable_wrapper__JRiA5","table":"AncetTable_table__SGKCb","question":"AncetTable_question__SuOCL","answer":"AncetTable_answer__DTMtf"};